import axios from '../utils/request'
import store from '../store'

const accountId = () => store.getters.accountId

export const fetch = (vars = {}, page = 1, limit = 30, serializer = null) => {
  return axios({
    url: `/business/exporters/${accountId()}/view/invoices_list_scf`,
    params: {
      limit: limit,
      page: page,
      vars: vars,
      serializer: serializer
    }
  })
}

export const getInvoiceMeta = () => {
  return axios({
    url: `/business/exporters/${accountId()}/view/invoices_list_counters_scf`
  })
}

const validateToken = async () => {
  try {
    const response = await axios({
      url: `/business/invoices/meta?authenticate`
    })
    // Assuming a valid token results in a successful response
    return response.status === 200 // or any other condition that indicates a valid token
  } catch (error) {
    console.error('Token validation error:', error)
    return false
  }
}

export const fetchPendingTasks = () => {
  return axios({
    url: `/business/exporters/${accountId()}`,
    params: {
      include: ['customer_pending_task_flows']
    }
  })
}

export const fetchSingleInvoice = (invoiceId) => {
  return axios({
    url: `/business/invoices/${invoiceId}`,
    params: {
      include: [
        'plan',
        'customer_pending_task_flows',
        'task_flows',
        'payment',
        'info',
        'exporter',
        'advances',
        'fees',
        'shipping_data',
        'form_data',
        'client_bank_detail',
        'statement_data',
        'fees_breakup_detailed'
      ]
    }
  })
}

export const downloadInvoice = (invoiceId) => {
  return axios({
    url: `/business/invoices/${invoiceId}/call/invoice_copy/`,
    responseType: 'blob',
    method: 'POST',
    params: {
      vars: {
        filename: `invoices-${invoiceId}-advice`
      }
    }
  })
}

export const fetchCalculationDetails = (invoiceId) => {
  return axios({
    url: `/business/invoices/${invoiceId}/view/calculation_details`
  })
}

export const fetchCalculationBreakup = (invoiceId, date) => {
  return axios({
    url: `/business/invoices/${invoiceId}/view/fee_calculation_breakup`,
    params: {
      vars: {
        as_on: date
      }
    }
  })
}

export const fetchSignableInvoices = (businessId) => {
  return axios({
    url: `/business/importers/${businessId}/signable-invoices`
  })
}

export const generateSignableInvoices = (accountId, userId, invoiceIds) => {
  return axios({
    url: 'business/invoices/call/start_scf_invoices_esigning',
    params: {
      vars: {
        account_id: accountId,
        user_id: userId,
        post_redirect: '/',
        invoice_ids: invoiceIds,
        clickwrap: true
      }
    }
  })
}

const downloadSwiftCopy = (madeFor = 'invoices', invId, type) => {
  return axios({
    baseURL: `${process.env.VUE_APP_DRIP_API_HOST}`,
    method: 'GET',
    url: `/v2/business/${madeFor}/${invId}/swift-copy${
      type ? '?type=' + type : ''
    }`,
    responseType: 'blob'
  })
}

const checkSwiftCopy = (madeFor = 'invoices', ids) => {
  if (madeFor === 'invoices') {
    return axios({
      baseURL: `${process.env.VUE_APP_DRIP_API_HOST}`,
      method: 'GET',
      url: `/v2/business/${madeFor}/check-swift-copies`,
      params: {
        invoice_ids: ids
      }
    })
  }
  return axios({
    baseURL: `${process.env.VUE_APP_DRIP_API_HOST}`,
    method: 'GET',
    url: `/v2/business/${madeFor}/check-swift-copies`,
    params: {
      advance_ids: ids
    }
  })
}

export default {
  fetch,
  getInvoiceMeta,
  fetchPendingTasks,
  downloadInvoice,
  fetchCalculationDetails,
  fetchCalculationBreakup,
  fetchSignableInvoices,
  generateSignableInvoices,
  downloadSwiftCopy,
  fetchSingleInvoice,
  checkSwiftCopy,
  validateToken
}
